import { DatePicker, Field, Box } from '@workwhile/ui'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ListingFunnelTimeRangeFormSchema } from './listingFunnelTimeRangeFormSchema'

export const ListingFunnelTimeRangeInputs = ({
  maxEndDate,
}: {
  maxEndDate: Date
}) => {
  const { control } = useFormContext<ListingFunnelTimeRangeFormSchema>()

  return (
    <Box>
      <Controller
        name="timeRange.dateRange"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Field error={error?.message?.toString()}>
            <DatePicker
              mode="range"
              disabled={{ after: maxEndDate }}
              selected={field.value}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              ref={field.ref}
              onSelect={(dateRange) => {
                field.onChange(dateRange)
              }}
              placeholder="Select Date range"
            />
          </Field>
        )}
      />
    </Box>
  )
}
